var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row justify-center"},[_c('NewCustomer',{staticClass:"mb-10"})],1),_c('CouponIsland',{staticClass:"mb-10"}),_c('WeeklySpecial',{staticClass:"mb-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }